export default "__VITE_ASSET__CNbnmvUV__"